import React, { useState } from 'react';
import parse from 'html-react-parser';
import { generateFormattedDate } from './assets/generateFormattedDate';
import { toast } from 'react-toastify';
import SimpleLightbox from './FlexLightbox';
import Modal from '../../../components/Modal/DefaultModal';
import ChatImageWithLightbox from './components/ChatImageWithLightbox';

import { FaReply, FaUserCircle } from 'react-icons/fa';
import {
  ClientTimestamp,
  ClientContent,
  ClientName,
  MessageContent,
  MessageText,
  ImageContent,
  ContentContact,
  InfoContact,
  ContentModalInfoContato,
  MessageHoverContainerClient,
  ReplyIconContainerClient,
  AudioContent
} from './components/styled';
import './style.css';
import { useSelector } from 'react-redux';
import ReplyMessage from './components/ReplyMessage';
import { isSourceExpired, handleDownloadMedia } from './utils';
import { MdFileDownload } from 'react-icons/md';
import DOMPurify from 'dompurify';
import { AudioChatBallon } from './styled';
import { FileMessageBallon } from './components/FileMessage/FileMessage';

const getContactNameWithPhoneAsFallback = (contact) =>
  contact?.name?.formatted_name ??
  contact?.phones?.[0]?.phone ??
  'Contato sem nome';

const ClientMessage = ({
  message = '',
  title = '',
  time = '',
  name = '',
  contact = [],
  type = 'text',
  source = '',
  sourceType = '',
  description = '',
  context,
  whatsappMessageId,
  setInReplyToMessageId,
  scrollToMessage,
  highlighted,
  isClientNotActive,
  todasMensagens
}) => {
  const isExpired = isSourceExpired(source, time);

  if (isExpired !== undefined && isExpired) {
    type = 'text';
    message = 'Link expirado com mais de 7 dias.';
    source = '';
  }

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  function findUrl(message) {
    if (!message) return '';
    const regexError = /<([^<>]+@[^<>]+)>/;
    const match = regexError.test(message);
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    const matchWebsite = urlRegex.test(message);

    if (match) message = message.replace('<', '').replace('>', '');
    if (matchWebsite) {
      const html = message.replace(urlRegex, function (url, initialWWW) {
        var urlWithHTTP = initialWWW == 'www.' ? 'http://' + url : url;
        return `<a href="${urlWithHTTP}" target="_blank">${url}</a>`;
      });
      return parse(html || '');
    }

    return message;
  }

  const copyToClipBoard = async (content) => {
    try {
      await navigator.clipboard.writeText(content);
      toast.info(`Mensagem copiada!`, { autoClose: 1500 });
    } catch (err) {
      console.log('error copy => ', err);
      toast.error('Erro ao copiar mensagem!', { autoClose: 1500 });
    }
  };

  const handleAnswerMessage = () => {
    setInReplyToMessageId(whatsappMessageId);
  };

  const isFile = (type === 'file' || type === 'DOCUMENT') && !!source;
  const mainText = title || (message && findUrl(DOMPurify.sanitize(message)));

  return (
    <MessageHoverContainerClient>
      <ClientContent id={whatsappMessageId} highlighted={highlighted}>
        {context && (
          <ReplyMessage
            context={context}
            handleScrollToMessage={() =>
              scrollToMessage(
                context?.metaMessageId || context.id_mensagem_whatsapp
              )
            }
            color={systemConfiguration.primary_color}
            backgroundColor={'#d1d1d1'}
          />
        )}
        <ClientName>{name}:</ClientName>
        <MessageContent>
          {!isFile && <MessageText>{mainText}</MessageText>}

          {isFile && (
            <>
              <FileMessageBallon 
                source={source} 
                description={message} 
                sourceType={sourceType} 
              />
              {description && (
                <MessageText style={{ marginTop: '8px' }}>
                  {findUrl(DOMPurify.sanitize(description))}
                </MessageText>
              )}
            </>
          )}
          {type === 'image' && (
            <ChatImageWithLightbox
              source={source}
              description={description}
              todasMensagens={todasMensagens}
              LightboxComponent={SimpleLightbox}
              typeFilter={['image', 'sticker']}
            />
          )}
          {type === 'sticker' && (
            <ChatImageWithLightbox
              source={source}
              description={description}
              todasMensagens={todasMensagens}
              LightboxComponent={SimpleLightbox}
              typeFilter={['image', 'sticker']}
            />
          )}
          {type === 'audio' && (
            <AudioContent style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AudioChatBallon src={source} controls={true} autoPlay={false} controlsList="nodownload" />
              <MdFileDownload 
                size={24} 
                style={{ cursor: 'pointer', color: '#6a5acd', flexShrink: 0 }}
                onClick={(e) => {
                  e.stopPropagation();
                  const ext = source.split('.').pop().split(/#|\?/)[0] || 'mp3';
                  handleDownloadMedia(source, ext, sourceType);
                }} 
              />
            </AudioContent>
          )}
          {type === 'video' && (
            <div>
              <ImageContent style={{ position: 'relative' }}>
                <video
                  src={source}
                  autoPlay={false}
                  controls={true}
                  controlsList="nodownload"
                  width="100%"
                  height="300"
                />
                <MdFileDownload 
                  size={24} 
                  style={{ position: 'absolute', top: 10, right: 10, zIndex: 10, cursor: 'pointer', color: '#fff', background: 'rgba(0,0,0,0.5)', borderRadius: '50%', padding: '4px' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const ext = source.split('.').pop().split(/#|\?/)[0] || 'mp4';
                    handleDownloadMedia(source, ext, sourceType);
                  }} 
                />
              </ImageContent>
              <MessageText>{description}</MessageText>
            </div>
          )}
          {type === 'contact' && (
            <ContentContact color={systemConfiguration.primary_color}>
              <InfoContact>
                <FaUserCircle size={40} color="#eCeCeC" />
                {contact && contact.length > 1 ? (
                  <div>
                    <span>
                      {contact
                        ? `${getContactNameWithPhoneAsFallback(
                            contact[0]
                          )} e mais ${contact.length - 1} contato(s)`
                        : 'Não foi possivel exibir contato'}
                    </span>
                  </div>
                ) : (
                  <div>
                    <span>
                      {contact
                        ? `${getContactNameWithPhoneAsFallback(contact[0])}`
                        : 'Não foi possivel exibir contato'}
                    </span>
                  </div>
                )}
              </InfoContact>
              <button onClick={() => toggleModal()}>VER CONTATO</button>
              <Modal
                show={isModalOpen}
                onModalToggle={(state) => setIsModalOpen(state)}
                title="Informações de contato(s)"
                showCloseButton={false}
              >
                <ContentModalInfoContato>
                  {contact.map((contato, index) => (
                    <div key={index} className="info">
                      <FaUserCircle size={85} color="#cdcdcd" />
                      <span className="contact-name">
                        {getContactNameWithPhoneAsFallback(contato)}
                      </span>
                      {contato.phones &&
                        contato.phones.map((tel, index) => (
                          <span
                            key={index}
                            style={{
                              cursor: 'pointer'
                            }}
                            onClick={() => copyToClipBoard(tel.phone)}
                          >
                            Celular: {tel.phone}
                          </span>
                        ))}
                      {contato.emails &&
                        contato.emails.map((email, index) => (
                          <span key={index}>E-mail: {email.email}</span>
                        ))}
                      {contato.addresses &&
                        contato.addresses.map((address, index) => (
                          <span key={index}>
                            <div>
                              Endereço: {address.street}. {address.city} -{' '}
                              {address.state}.
                            </div>{' '}
                            <span>
                              {address.country} - CEP: {address.zip}
                            </span>
                          </span>
                        ))}
                      {contato.urls &&
                        contato.urls.map((url, index) => (
                          <span key={index}>Site: {url.url}</span>
                        ))}
                    </div>
                  ))}
                </ContentModalInfoContato>
              </Modal>
            </ContentContact>
          )}
        </MessageContent>
        {whatsappMessageId && !isClientNotActive && (
          <ReplyIconContainerClient>
            <FaReply onClick={handleAnswerMessage} title="Responder" />
          </ReplyIconContainerClient>
        )}
        <ClientTimestamp>{time && generateFormattedDate(time)}</ClientTimestamp>
      </ClientContent>
    </MessageHoverContainerClient>
  );
};

export default ClientMessage;